import {
  Empty,
  EmptyHeadline,
  EmptyDescription,
  CircleXIcon,
} from '@frontend/components';

type BaseErrorFallbackProps = {
  size?: 'sm' | 'md' | 'lg';
};

const BaseErrorFallback = ({ size = 'md' }: BaseErrorFallbackProps) => (
  <Empty size={size}>
    <CircleXIcon color="alert.error" />
    <EmptyHeadline>An unknown error occurred</EmptyHeadline>
    <EmptyDescription>Please refresh this page and try again.</EmptyDescription>
  </Empty>
);

export default BaseErrorFallback;
